import type { SVGProps } from 'react';
const SvgBoxArchive = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path d="M48 80v48h416V80zM32 32h448c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32m128 216c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24M32 416V208h48v208c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V208h48v208c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64" />
  </svg>
);
export default SvgBoxArchive;
